// extracted by mini-css-extract-plugin
export var subtitle = "_cr-2";
export var title = "_cr-0";
export var titleNoWrap = "_cr-1";